import { Link } from 'gatsby';
import { useMemo, type FC } from 'react';
import { industryPath } from '../../lib/industry-routes';
import SubscribeBox from '../blog/subscribe-box';

export type IndustryNavItem = {
  Slug: string;
  Title: string;
  position?: number | null;
};

const IndustriesLeftSidebar: FC<{
  industries: IndustryNavItem[];
  activeSlug: string | null;
}> = ({ industries, activeSlug }) => {
  const items = useMemo(
    () =>
      [...industries].sort((a, b) => {
        const posA = a.position ?? Number.MAX_SAFE_INTEGER;
        const posB = b.position ?? Number.MAX_SAFE_INTEGER;
        if (posA !== posB) return posA - posB;
        return a.Title.localeCompare(b.Title);
      }),
    [industries],
  );

  return (
    <aside className="industries-sidebar about-sidebar pointer-events-auto relative z-30 md:col-span-3">
      <div
        className="industries-sidebar__panel space-y-6 md:sticky md:flex md:max-h-[calc(100dvh-var(--header-total-height,116px)-1.5rem)] md:flex-col md:gap-6 md:space-y-0 md:overflow-hidden"
        style={{ top: 'var(--header-total-height, 116px)' }}
      >
        <div className="industries-sidebar__section min-h-0 md:flex md:min-h-0 md:flex-1 md:flex-col">
          <p
            className="shrink-0 text-xl uppercase font-semibold text-[#1B1C1B] sm:text-2xl"
            style={{
              fontFamily: 'Inter',
              lineHeight: '33.6px',
              letterSpacing: '-0.6px',
            }}
          >
            INDUSTRIES
          </p>
          <nav
            aria-label="Industries"
            className="industries-sidebar__nav mt-4 bg-white md:min-h-0 md:flex-1 md:overflow-y-scroll md:overscroll-contain"
          >
            {items.map((industry) => {
              const isActive = industry.Slug === activeSlug;
              const href = industryPath(industry.Slug);

              return (
                <Link
                  className={`relative block py-4 pl-6 pr-4 ${
                    isActive ? 'bg-[#F5F3F1]' : ''
                  }`}
                  key={industry.Slug}
                  to={href}
                >
                  <span
                    className="absolute left-0 top-0 h-full"
                    style={{ width: 1, background: '#E4BEB8' }}
                  />
                  {isActive ? (
                    <span
                      className="absolute left-0 top-0 h-full"
                      style={{
                        width: 4,
                        background:
                          'linear-gradient(108.74deg, #990400 0%, #FF8A00 100%)',
                      }}
                    />
                  ) : null}
                  <span
                    className="align-middle"
                    style={{
                      fontFamily: 'Inter',
                      fontWeight: 400,
                      fontSize: 16,
                      lineHeight: '24px',
                      letterSpacing: '0px',
                      ...(isActive
                        ? {
                            backgroundImage:
                              'var(--header-accent-gradient, linear-gradient(108.74deg, #990400 0%, #FF8A00 100%))',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            color: 'transparent',
                            WebkitTextFillColor: 'transparent',
                          }
                        : { color: '#5B403C' }),
                    }}
                  >
                    {industry.Title}
                  </span>
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="shrink-0">
          <SubscribeBox />
        </div>
      </div>
    </aside>
  );
};

export default IndustriesLeftSidebar;
